<div class="on-site-training-tile" *ngIf="data" id="tile">
    <div class="above-tile">
        <div class="above-tile__blue" *ngIf="data.isOnSiteTraining === 1">
            {{'OnSiteTrainingCreator.DateTypeOnSite' | translate}}
        </div>
        <div class="above-tile__dark-blue2" *ngIf="data.isOnSiteWebinar === 1">
            {{'OnSiteTrainingCreator.DateTypeWebinar' | translate}}
        </div>
        <div class="above-tile__green" *ngIf="data.isNew === 1">
            {{'Common.Novelty' | translate}}
        </div>
    </div>

    <div class="on-site-training-tile__image"
         (click)="previewTraining()">
        <img [src]="data.photoUrl" alt="photo" loading="lazy">

        <div class="dolineo-icon dolineo-icon-white" *ngIf="data.isDolineo">
            <img src="/assets/icons/dolineo.svg" loading="lazy" alt="dolineo">
        </div>
    </div>

    <div class="on-site-training-tile__container">
        <div class="on-site-training-tile__container__times on-site-training">
            <div style="display: flex; width: 100%">
                <span class="calendar" *ngIf="!data.finishedDate && data.onSiteTrainingAssignedStartDate">
                    <img src="/assets/icons/calendar2.svg" alt="calendar2"
                         loading="lazy"
                         matTooltip="{{'Common.RealisationDate' | translate}}"
                         matTooltipPosition="below"
                         matTooltipClass='below-top'>
                    <span>
                        {{ data.onSiteTrainingAssignedStartDate }}
                    </span>
                </span>

                <span class="finish-green" *ngIf="data.finishedDate">
                    <img src="assets/icons/checked-without-bg.svg"
                         loading="lazy"
                         alt="checked-without-bg">
                    <span>{{ 'Common.FinishedDate' | translate | uppercase }}</span>
                </span>

                <span class="clock" *ngIf="data.durationTime">
                    <img src="/assets/icons/clock.svg" alt="clock"
                         loading="lazy"
                         matTooltip="{{'PathCreator.Duration' | translate}}"
                         matTooltipPosition="below"
                         matTooltipClass='below-top'>
                    <span>{{ data.durationTime }}</span>
                </span>

                <span class="heart" *hasAccess="[]; perms ['user:favourites']">
                    <img [src]="(data.isFavourite? 'assets/icons/heart-like.svg': 'assets/icons/heart-empty.svg')"
                         loading="lazy"
                         (click)="updateLike(data)"
                         alt="heart"
                         matTooltip="{{(data.isFavourite?'Favourite.RemoveFromFavorites': 'Favourite.AddToFavourite')  | translate}}"
                         matTooltipPosition="below"
                         matTooltipClass='below-top'>
                    <span *ngIf="data.favouritesCount > 0">{{ data.favouritesCount }}</span>
                </span>
            </div>

            <div class="three-dots"
                 *ngIf="showMore && ((canEdit && !data.isDolineo) ||
                          canSelfAssign ||
                           canAssign)">
                <button mat-button [matMenuTriggerFor]="more"
                        type="button"
                        matTooltip="{{'Common.More' | translate}}"
                        matTooltipPosition="below"
                        matTooltipClass='below-top'>
                    <img src="/assets/icons/dot_v.svg"
                         loading="lazy"
                         alt="dot_v">
                </button>
                <mat-menu #more="matMenu">
                    <button mat-menu-item (click)="goEdit()" *ngIf="canEdit && !data.isDolineo">
                        {{'Training.EditTraining' | translate}}
                    </button>
                </mat-menu>
            </div>
        </div>

        <div class="on-site-training-tile__container__title">
            <span (click)="previewTraining()"
                  [innerHTML]="(data.name | safe: 'text') | yellowSearchText : searchText | safe: 'html'"></span>
        </div>

        <div class="on-site-training-tile__footer" *ngIf="data.idOnSiteTraining"
             [ngStyle]="{'justify-content': data.totalElementsCount? 'space-between': 'flex-end'}">
            <div class="on-site-training-tile__footer--available-dates" *ngIf="!data.onSiteTrainingAssignedStartDate && data.availableDatesCount && data.availableDatesCount > 0">
                <div class="on-site-training-tile__footer--available-dates--label">{{'OnSiteTraining.AvailableDates' | translate}}:</div>
                <div class="on-site-training-tile__footer--available-dates--count">{{data.availableDatesCount}}</div>
            </div>
            <div class="on-site-training-tile__footer--status" (click)="assign(data, data.status)"[innerHTML]="getAssignButton(data.status)">

            </div>
        </div>
    </div>
</div>
